import { apiFetch } from './client';

// ============================================================
// VIX Analysis API client - PR-3.
// Mirror del endpoint /api/sessions/:sessionId/pnl-vs-vix.
// ============================================================

export type VixTimeframe = '1m' | '5m';

export interface VixTimelineRow {
  time: string; // HH:mm ET wall-clock
  timestamp: number; // epoch ms (inicio del bucket)
  pnl: number;
  vix: number | null;
}

export interface VixTradeEvent {
  side: 'long' | 'short' | null;
  entryTime: string | null;
  exitTime: string | null;
  entryPrice: number | null;
  exitPrice: number | null;
  profit: number; // BT-style
  exitReason: string | null;
}

export interface VixStats {
  correlation: number | null;
  vixMin: number | null;
  vixMax: number | null;
  vixFirst: number | null;
  vixLast: number | null;
  vixDelta: number | null;
  pnlTotal: number;
  tradesTotal: number;
  tradesWin: number;
  tradesLoss: number;
  vixBarsReceived: number;
  vixFetchOk: boolean;
  vixFetchError: string | null;
}

export interface VixResponse {
  session: {
    sessionId: string;
    symbol: string;
    startTime: string;
    endTime: string;
    timeframe: VixTimeframe;
  };
  timeline: VixTimelineRow[];
  trades: VixTradeEvent[];
  stats: VixStats;
}

export async function fetchPnLvsVix(
  sessionId: string,
  timeframe: VixTimeframe = '5m',
): Promise<VixResponse> {
  const qs = new URLSearchParams({ timeframe });
  return await apiFetch<VixResponse>(
    `/api/sessions/${encodeURIComponent(sessionId)}/pnl-vs-vix?${qs}`,
  );
}
